module.exports = __webpack_public_path__ + "img/标准策略.475c8f06.svg";